import Avatar from "@mui/material/Avatar"
import Button from "@mui/material/Button"
import TextField from "@mui/material/TextField"
import { Formik, Form } from "formik"
import React from "react"
import * as Yup from "yup"

import i18n from "@/i18n"

const validationSchema = Yup.object({
  name: Yup.string().required(i18n.t("app.reservation.labels.name") + " is required"),
  email: Yup.string().email("Invalid email").nullable(),
  phone: Yup.string().nullable(),
})

interface CustomerDetailsEditProps {
  customer: any
  customerContact: any
  onSubmit: (values: any) => Promise<void>
  onCancel: () => void
  loading: boolean
}

const CustomerDetailsEdit: React.FC<CustomerDetailsEditProps> = ({
  customer: _customer,
  customerContact,
  onSubmit,
  onCancel,
  loading,
}) => {
  return (
    <Formik
      initialValues={{
        name: customerContact.name || "",
        email: customerContact.email || "",
        phone: customerContact.phone || "",
      }}
      validationSchema={validationSchema}
      onSubmit={onSubmit}
    >
      {(formik) => (
        <Form data-testid="panel-clients-modal-details-edit-form" className="flex flex-col h-full">
          <div className="flex items-start mb-6">
            <Avatar src={customerContact.avatarUrl} className="w-16 h-16" />
            <div className="ml-4 flex-1 flex flex-col gap-4">
              <div className="flex gap-2 mb-2">
                <TextField
                  data-testid="panel-clients-modal-details-edit-name"
                  name="name"
                  label={i18n.t("app.reservation.labels.name")}
                  value={formik.values.name}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  error={Boolean(formik.touched.name && formik.errors.name)}
                  helperText={(formik.touched.name && formik.errors.name) as string}
                  size="small"
                  fullWidth
                />
              </div>

              <TextField
                data-testid="panel-clients-modal-details-edit-phone"
                name="phone"
                label={i18n.t("app.reservation.labels.phone")}
                value={formik.values.phone}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                error={Boolean(formik.touched.phone && formik.errors.phone)}
                helperText={(formik.touched.phone && formik.errors.phone) as string}
                size="small"
                fullWidth
                className="mb-2"
              />

              <TextField
                data-testid="panel-clients-modal-details-edit-email"
                name="email"
                label={i18n.t("app.reservation.labels.email")}
                value={formik.values.email}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                error={Boolean(formik.touched.email && formik.errors.email)}
                helperText={(formik.touched.email && formik.errors.email) as string}
                size="small"
                fullWidth
                className="mb-2"
              />
            </div>
          </div>

          <div className="mt-auto flex justify-between gap-2">
            <Button
              data-testid="panel-clients-modal-details-edit-cancel"
              variant="text"
              size="small"
              onClick={onCancel}
              disabled={loading}
            >
              {i18n.t("app.clients.client_modal.cancel_button")}
            </Button>
            <Button
              data-testid="panel-clients-modal-details-edit-save"
              variant="contained"
              size="small"
              type="submit"
              disabled={loading || !formik.isValid}
            >
              {i18n.t("app.clients.client_modal.update_button")}
            </Button>
          </div>
        </Form>
      )}
    </Formik>
  )
}

export default CustomerDetailsEdit
